import {logEvent} from "@/utils/analytics";
import {
  Auth,
  AuthError,
  signInWithEmailLink as firebaseSignInWithEmailLink,
  UserCredential,
} from "firebase/auth";
import {useCallback, useState} from "react";

type AuthActionHook<M> = [
  M,
  boolean,
  AuthError | undefined,
  UserCredential | undefined,
];

export type SignInWithEmailLinkHook = AuthActionHook<
  (email: string, emailLink?: string) => Promise<UserCredential | undefined>
>;

export const useSignInWithEmailLink = (auth: Auth): SignInWithEmailLinkHook => {
  const [error, setError] = useState<AuthError>();
  const [loggedInUser, setLoggedInUser] = useState<UserCredential>();
  const [loading, setLoading] = useState<boolean>(false);

  const signInWithEmailLink = useCallback(
    async (email: string, emailLink?: string) => {
      setLoading(true);
      setError(undefined);
      try {
        const user = await firebaseSignInWithEmailLink(auth, email, emailLink);
        setLoggedInUser(user);
        logEvent("logged_in", {method: "email_link"});

        return user;
      } catch (err) {
        const authError = err as AuthError;
        // log to GA
        logEvent("login_error", {error: authError?.message});
        setError(authError);
      } finally {
        setLoading(false);
      }
    },
    [auth],
  );

  return [signInWithEmailLink, loading, error, loggedInUser];
};
